export const MARKING_CURVE = 'CURVA';
export const MARKING_MARKET = 'MERCADO';

/**
* Retorna as opções de título público ou privado
* @return {Array} 
*/
export function getOptionsSectorTitle() {

    return [
        "PUBLICO",
        "PRIVADO"
    ]
}

/**
* Retorna os tipos de marcação de um título CURVA ou MERCADO
* @return {Array} Array com os tipos de marcação do título
*/
export function getOptionsMarkingTitle() {

    return [
        MARKING_CURVE,
        MARKING_MARKET
    ]
}

/**
* Retorna as opções de indexadores
* @return {Array}
*/
export function getOptionsIndexersTitle() {

    return [
        "CDI",
        "IPCA",
        "IGPM"
    ]
}

/**
* Calcula a média ponderada das taxas de marcação (curva) de uma lista de títulos,
* ponderada pelo Valor Atual (balance_now) de cada título.
* - Apenas títulos de curva com taxa (pre_tax) válida entram no cálculo, usando a
*   mesma condição de exibição por linha (pre_tax truthy e marking != MERCADO).
* - Os títulos ignorados NÃO entram no denominador ("Valor Atual Total Considerado").
* @param {Array} titles lista de títulos com campos pre_tax, marking e balance_now
* @return {number|null} média ponderada em % ou null quando não há título válido
*/
export function getWeightedMarkingAverage(titles) {

    if (!titles || !titles.length) return null;

    let weightedSum = 0;
    let consideredAmount = 0;

    titles.forEach(t => {
        const rate = parseFloat(t.pre_tax);
        const amount = parseFloat(t.balance_now);
        const hasValidRate = t.pre_tax && t.marking !== MARKING_MARKET;
        if (hasValidRate && Number.isFinite(rate) && Number.isFinite(amount)) {
            weightedSum += rate * amount;
            consideredAmount += amount;
        }
    });

    if (consideredAmount <= 0) return null;

    return weightedSum / consideredAmount;
}